import { useEffect, useState } from "react";

import { OlgaEnvironmentsAPI } from "../../../providers/OlgaEnvironmentsAPI";
import { Folder } from "../../core/Folder";
import CreateFolderDrawer from "./folders/CreateFolderDrawer";
import RemoveFolderDrawer from "./folders/RemoveFolderDrawer";

const steps = {
  CREATE_NEW_FOLDER: "CREATE_NEW_FOLDER",
  REMOVE_FOLDER: "REMOVE_FOLDER",
};

export default function FoldersDrawer({
  visible,
  onClose,
  onLoadFolders,
  onLoadCoupons,
}) {
  const [step, setStep] = useState(steps.CREATE_NEW_FOLDER);
  const [folderToRemove, setFolderToRemove] = useState(null);
  const [loading, setLoading] = useState(true);

  const [folders, setFolders] = useState([]);

  useEffect(() => {
    if (visible) {
      setStep(steps.CREATE_NEW_FOLDER);
      loadFolders();
    }
  }, [visible]);

  const loadFolders = async () => {
    setLoading(true);
    const environmentConfigurations =
      await OlgaEnvironmentsAPI.getConfigurations();
    const folders = environmentConfigurations.getData({})?.coupon_folders || [];
    setFolders(folders.map((folder) => new Folder(folder)));
    setLoading(false);
  };

  return (
    <>
      <CreateFolderDrawer
        folders={folders}
        visible={visible}
        onAddFolders={() => loadFolders()}
        onUpdateFolders={(folders) => setFolders(folders)}
        onClose={onClose}
        onRemove={(folder) => {
          setFolderToRemove(folder);
          setStep(steps.REMOVE_FOLDER);
        }}
        loading={loading}
      />

      <RemoveFolderDrawer
        visible={step === steps.REMOVE_FOLDER}
        folder={folderToRemove}
        onClose={() => {
          setStep(null);
          onClose();
        }}
        onBack={() => {
          loadFolders();
          setFolderToRemove(null);
          setStep(steps.CREATE_NEW_FOLDER);
        }}
        onLoadFolders={() => {
          onLoadFolders();
          loadFolders();
        }}
        onLoadCoupons={onLoadCoupons}
      />
    </>
  );
}
